import React from "react";
import best2 from "../assets/best2.jpg";
import "../style/bestSeller.css";

function BestSeller2() {
  return (
    <div>
      <img src={best2} alt="best seller images" className="best" />
    </div>
  );
}

export default BestSeller2;
